

export const getAdImageUrl = (API_ROOT) => {
  const sessionStarted = sessionStorage.getItem("adSessionStarted");

  const count = parseInt(
    localStorage.getItem("adVisitCount") || "0",
    10
  );

  let newSession = sessionStarted !== "true";

  if (newSession) {
    sessionStorage.setItem("adSessionStarted", "true");
  }


  return `${API_ROOT}/api/advertisement/get_active?newSession=${newSession}`;
};

